import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {setDefaultMap,zoomTo,setMapToggle,clearMapTracking} from './js/MapAlertSummaryReport';


class MapAlertSummaryReport extends Component {
    constructor(props) {
		super(props);
		this.state = {
            mapTogglePath:'images/pin/type_sat.png'
		};
    }
    componentDidMount(){
        setDefaultMap();
        // updateMapSize();
        this.zoomTo();
    }
    componentWillUnmount(){
        clearMapTracking();
    }
    zoomTo(){
        const { index, lat, lng, text, symbolId, symbolColor } = this.props;
        zoomTo(index, lat, lng, text, symbolId, symbolColor);
    }

    handleSetMapToggle(){
        let p = setMapToggle(this.state.mapTogglePath);
        this.setState({mapTogglePath : p});
    }

    render() {
        const { handleFullScreenToggle, isFullScreen  } = this.props;
        let styleToggle={
            position: 'absolute',
            right: 7,
            top: 85,
            zIndex: 1,
            width: 60,
            cursor: 'pointer'
        }
        return (
            <div style={{height:"100%"}}>
                <img style={styleToggle}  src={this.state.mapTogglePath} className="img-thumbnail" onClick={this.handleSetMapToggle.bind(this)}/>
                <div id="mapAlert" className="map" ref="map" >
                    <i className={`btn-map-extent fab fa-red-river ${isFullScreen ? 'fa-rotate-180' : ''}`} onClick={handleFullScreenToggle}>{''}</i>
                </div>

            </div>
        )
    }
}
MapAlertSummaryReport.defaultProps = {
    index: 0,
    lat: 0,
    lng: 0,
    text: '',
    symbolId: '',
    symbolColor: ''
}

MapAlertSummaryReport.propTypes = {
    index: PropTypes.number,
    lat: PropTypes.number,
    lng: PropTypes.number,
    text: PropTypes.string,
    symbolId: PropTypes.string,
    symbolColor: PropTypes.string,
    handleFullScreenToggle: PropTypes.func.isRequired,
    isFullScreen: PropTypes.bool.isRequired
}
export default MapAlertSummaryReport;



// WEBPACK FOOTER //
// ./src/app/view/components/Report/MapAlertSummaryReport.js